import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as apiOrdersService from '../../services/apiOrdersService'
import Currency from './currency'
import * as dateUtil from '../../util/date.util'
import { BASE_IMAGE_PATH } from '../../configs/api';
class MarketOrderModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         orders_data: [],
         last_id: "",
         first_id: "",
         action: "",
         from: "",
         to: "",
         page_no: 1,
         count_records: 0,
         records_display: 25,
         loader: false,
         total_page: 1,
         showData: false,

      };
   }
   componentDidMount() {
      this.submitForm()
   }
   parseFilterBody() {
      // let body = {
      //    "filters": {
      //       "BetStatuses": ["WON", "LOST", "VOID", "DECLARED"],
      //       "user_id": !!this.props.user_id ? this.props.user_id : "",
      //       "current_user": this.props.current_user,
      //       "amount_from": 0.0,
      //       "amount_to": 0.0,
      //       "market_id": this.props.market_id,
      //       "event_id": "",
      //       "event_type_category": "",
      //       "competition_id": "",
      //       "sport_type": "",
      //       "market_type": "",
      //    },
      //    "last_id": this.state.last_id,
      //    "first_id": this.state.first_id,
      //    "action": this.state.action,
      //    "from": "",
      //    "to": "",
      //    "page_no": this.state.page_no,
      //    "count_records": this.state.count_records,
      //    "records_display": this.state.records_display
      // }
      let body = {
         "filters":{
             "userId": !!this.props.user_id ? this.props.user_id : "",
             "betStatus": ["WON", "LOST", "VOID", "DECLARED"],
             "marketId": this.props.market_id,
             "eventId": "",
             "eventTypeCategory": "",
             "competitionId": "",
             "sportType": "",
             "marketType": "",
             "amountFrom": 0.0,
             "amountTo": 0.0
         },
         "lastId": this.state.last_id,
         "firstId": this.state.first_id,
         "action": this.state.action,
         "from": "",
         "to": "",
         "countRecords": this.state.count_records,
         "pageNo": this.state.page_no,
         "recordsPerPage": this.state.records_display
     }
      body = this.clean(body)
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({loader: true, showData: true})
      await apiOrdersService.postApiOrder(body).then((res) => {
         if (res.isSuccess) {
            self.setState(
               {
                  orders_data: [],
                  last_id: res.lastId,
                  first_id: res.firstId,
                  action: res.action,
                  page_no: res.pageNo,
                  count_records: res.countRecords,
                  total_page: 1,
               }, () => {
                  this.setState({
                     orders_data: res.items,
                     total_page: Math.ceil(res.countRecords / this.state.records_display),
                     loader: false
                  })
               }
            );
         }
         else {
            this.setState({ orders_data: [], showData: true, loader: false, total_page: 1, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
         }
      })

   }
   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 31) {
         this.props.notify(" Date range must be 1 month. ", "error");
      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   closePopup() {
      this.setState({ from: "", to: "", showData: false, orders_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, records_display: 25 })
      this.props.hidePopupBets()
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value });
   }
   onAction(e) {
      const name = e.target.name;
      const value = e.target.value;
      if (name === "page_no") {
         this.setState({ [name]: parseInt(value), last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      if (name === "last") {
         this.setState({ page_no: this.state.total_page, last_id: "", action: "", first_id: "" }, () => { this.submitForm(); });
      }
      else if (name === "prev" || name === "next" || name === "first") {
         this.setState({ action: name }, () => { this.submitForm(); });
      }
   }
   onPagination() {
      let lst = []
      let total_page = this.state.total_page
      for (let x = 1; x <= total_page; x++) {
         if (this.state.page_no === x || Math.abs(x - this.state.page_no) <= 2 || (this.state.page_no < 3 && x < 6) || (total_page - this.state.page_no < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.page_no === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} name="page_no" value={x} onClick={(e) => { this.onAction(e) }}>{x} </button>
            lst.push(htm)
         }
      }
      return lst
   }
   render() {
      let page_no = parseInt(this.state.page_no)
      let count_records = parseInt(this.state.count_records)
      let records_display = parseInt(this.state.records_display)
      let current_record = 0
      let total_record = 0
      let start_record = 0
      if (count_records > (records_display * page_no)) {
         current_record = records_display * page_no
         total_record = count_records
         start_record = current_record - (records_display - 1)
      } else if (this.state.orders_data.length > 0) {
         current_record = count_records
         total_record = count_records
         start_record = ((page_no - 1) * records_display) + 1
      }
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="eventunsettle" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-lg modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Market Bets</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop pt-0">
                        {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}><img alt="" style={{width: "45px"}} src={BASE_IMAGE_PATH + "/aimg/loader.gif"}></img></div> : null}
                        {!!this.state.showData &&
                           <div>
                              <div className="row">
                                 <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div className="table-responsive">
                                       <table id="example" className="table font-12 table-bordered table-sm addpadding mt-2">
                                          <thead>
                                             <tr>
                                                {/* <th className="pthead">ID</th> */}
                                                <th className="pthead">User</th>
                                                <th className="pthead">Competition</th>
                                                <th className="pthead">Event</th>
                                                <th className="pthead">Market</th>
                                                <th className="pthead">Runner</th>
                                                <th className="pthead rw-40">Side</th>
                                                <th className="text-right pthead rw-40">Line</th>
                                                <th className="text-right pthead rw-45">Rate</th>
                                                <th className="text-right pthead rw-80">Amount</th>
                                                <th className="text-right pthead rw-80" title="Profit/Loss">P/L</th>
                                                <th className="pthead rw-50">Status</th>
                                                <th className="pthead rw-80">Client IP</th>
                                                <th className="pthead">Date &amp; Time</th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {!!this.state.loader ?
                                                <tr>
                                                   <td colSpan={15} align="center">
                                                      <img alt="" style={{width: "45px"}} src={BASE_IMAGE_PATH + "/aimg/loader.gif"}></img>
                                                   </td>
                                                </tr> :
                                                this.state.orders_data.length > 0 ? this.state.orders_data.map((order, i) => {
                                                   if(order.eventTypeId === "99" && order.betStatus === "VOID"){
                                                      return null
                                                   }

                                                   let st = (order.createdAt).split(" ")
                                                   let dtstr = st[0] + "T" + st[1] + ".000+00:00"
                                                   let dt = new Date(dtstr).toLocaleString("hi-IN")
                                                   const tm = !!dt ? dt.split(',')[1] : "";
                                                   dt = !!dt ? dt.split(',')[0] : "";
                                                   let price = order.price
                                                   let competitionName = order.competitionName ? (order.eventTypeId === '300' ? dateUtil.getBinaryCompetitionDisplayName(order.competitionName) : order.competitionName) : "-"
                                                   if(order.eventTypeId === '300'){
                                                            order.marketTime =  dateUtil.getBinaryMarketDisplayName(order.marketName)
                                                        }
                                                   return (
                                                      <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                         {/* <td className="idwidth" title={order.orderId ? order.orderId : "-"}>{order.orderId ? order.orderId : "-"}</td> */}
                                                         <td>{order.username ? order.username : "-"}</td>
                                                         <td>{competitionName}</td>
                                                         <td>{order.eventTypeId === '300' && !!order.marketTime && order.marketTime.length > 0 ? 
                                                            <>
                                                            {order.marketTime[0] }
                                                            <span className=''> [<b>{(order.marketTime.length > 0 ? order.marketTime[1] : "")}</b>]</span>
                                                            </>
                                                            
                                                            : !!order.eventName ? order.eventName : "-"}</td>
                                                         <td>{!!order.marketName ? order.marketName : "-"}</td>
                                                         <td>{!!order.runnerName ? order.runnerName : "-"}</td>
                                                         <td>{order.side === 0 ? "Back" : order.side === 1 ? "Lay" : order.side === -1 ? "Unknown" : "-"}</td>
                                                         <td className="text-right fbold">{order.marketBettingType === "LINE" && !!order.runnerId ? order.runnerId : "-"}</td>
                                                         <td className="text-right fbold">{!!price ? price : "0.00"} </td>
                                                         <td className="text-right fbold">{!!order.amount ? <Currency className="fbold" amount={order.amount} showColor={false} /> : "0.00"}</td>
                                                         {order.eventTypeId !== "99" ?
                                                         <td className="text-right fbold"> <Currency className="fbold" amount={order.betStatus === "WON" ? order.potentialProfit : order.betStatus === "LOST" ? order.potentialLoss : "0.00"} showColor={true} /> </td>
                                                         : <td className="text-right">-</td>
                                                         }
                                                         <td>{!!order.betStatus ? order.betStatus : "-"}</td>
                                                         <td>{!!order.clientIp ? order.clientIp : "-"}</td>
                                                         <td title={!!dt ? dt : "-"}><span>{!!dt ? dt : "-"} {!!tm ? tm : "-"}</span></td>
                                                      </tr>
                                                   );
                                                }) : <tr>
                                                      <td colSpan={26} align="center">
                                                         No Data Found.
                                       </td>
                                                   </tr>}
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                           </div>}
                     </div>
                     <div className="modal-footer">
                        <div className="row w-100">
                           <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                           <div className="col-12 col-sm-12 col-md-6">
                              <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                 <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>First</button>
                                 <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" && this.state.page_no === 1 ? true : false}>Prev</button>
                                 {this.onPagination()}
                                 <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Next</button>
                                 <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" && this.state.page_no === this.state.total_page ? true : false}>Last</button>
                              </div>
                           </div>
                        </div>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.closePopup() }}></div>
               </div>            
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(MarketOrderModel);